import {h} from 'preact'
import GitHubButton_ from 'react-github-btn'
import memoOne from '@essentials/memoize-one'
import type {DashLibraries} from '../types'

export const GitHubButton = memoOne(
  ({library = 'styles'}: GitHubButtonProps) => (
    <GitHubButton_
      href={`https://github.com/dash-ui/${library}`}
      data-color-scheme='no-preference: dark; light: dark; dark: dark;'
      data-size='large'
      data-show-count
      aria-label={`Star dash-ui/${library} on GitHub`}
    >
      @dash-ui/{library}
    </GitHubButton_>
  ),
  (current, prev) => current[0].library === prev[0].library
)

export interface GitHubButtonProps {
  library?: DashLibraries
}
